import React from "react";
import {
  Button,
  CircularProgress,
  createStyles,
  withStyles
} from "@material-ui/core";
import { magicLinkColors, magicLinkRadius } from "./magicLinkTokens";

interface Props {
  variant?: "primary" | "outline";
  type?: "button" | "submit";
  disabled?: boolean;
  loading?: boolean;
  onClick?: () => void;
  id?: string;
  className?: string;
  style?: React.CSSProperties;
  startIcon?: React.ReactNode;
  endIcon?: React.ReactNode;
  children: React.ReactNode;
  classes: Record<string, string>;
}

const styles = (theme: any) =>
  createStyles({
    root: {
      height: 34,
      minWidth: 0,
      padding: "8px 12px",
      borderRadius: magicLinkRadius.button,
      fontFamily: "Nunito Sans",
      fontSize: "12px",
      fontWeight: 600,
      lineHeight: 1,
      textTransform: "none",
      whiteSpace: "nowrap",
      boxShadow: "none"
    },
    primary: {
      backgroundColor: theme.palette.primary.main,
      color: "#FFFFFF",
      "&:hover": {
        backgroundColor: theme.palette.primary.dark,
        boxShadow: "none"
      }
    },
    outline: {
      backgroundColor: "#FFFFFF",
      color: magicLinkColors.textStrong,
      border: `1px solid ${theme.palette.primary.main}`,
      "&:hover": {
        backgroundColor: magicLinkColors.optionActive
      }
    },
    disabled: {
      backgroundColor: `${magicLinkColors.disabled} !important`,
      color: `${magicLinkColors.textMuted} !important`,
      border: "none"
    },
    startIcon: {
      marginLeft: 0,
      marginRight: 4
    },
    endIcon: {
      marginLeft: 4,
      marginRight: 0
    },
    spinner: {
      marginRight: 6,
      color: "inherit"
    }
  });

const MagicLinkButton = ({
  variant = "primary",
  type = "button",
  disabled,
  loading,
  onClick,
  id,
  className,
  style,
  startIcon,
  endIcon,
  children,
  classes
}: Props) => (
  <Button
    id={id}
    type={type}
    disabled={disabled || loading}
    onClick={onClick ? () => onClick() : undefined}
    disableElevation
    classes={{
      root: classes.root,
      disabled: classes.disabled,
      startIcon: classes.startIcon,
      endIcon: classes.endIcon
    }}
    className={[classes[variant], className].filter(Boolean).join(" ")}
    style={style}
    startIcon={startIcon}
    endIcon={endIcon}
  >
    {loading && <CircularProgress size={12} className={classes.spinner} />}
    {children}
  </Button>
);

export default withStyles(styles)(MagicLinkButton);
